<template>
    <UtilitiesWebView url="/visit-the-center" />
</template>
